import { FormControlLabel } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";

export default function AppCheckbox({
    label,
    checked,
    onChange,
    fontSize = "0.9rem",
    fontWeight = "normal",
    ...otherProps
}) {
    return (
        <FormControlLabel
            sx={{
                ".MuiFormControlLabel-label": {
                    fontSize: fontSize,
                    fontWeight: fontWeight,
                },
            }}
            control={
                <Checkbox
                    checked={checked}
                    onChange={onChange}
                    {...otherProps}
                />
            }
            label={label}
        />
    );
}
